import React from 'react';
export function AboutSection() {
  return <section id="about" className="py-16 md:py-24 bg-white" data-id="element-14">
      <div className="container mx-auto px-4" data-id="element-15">
        <div className="text-center mb-12" data-id="element-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-17">
            About Us
          </h2>
          <div className="w-24 h-1 bg-amber-500 mx-auto" data-id="element-18"></div>
        </div>
        <div className="max-w-4xl mx-auto text-center" data-id="element-19">
          <p className="text-lg text-gray-700 mb-6 leading-relaxed" data-id="element-20">
            New Louzan Building Maintenance is a premier service provider
            dedicated to excellence in the maintenance industry across Ajman and
            Dubai. With years of experience and a team of skilled professionals,
            we deliver comprehensive maintenance solutions tailored to both
            residential and commercial properties.
          </p>
          <p className="text-lg text-gray-700 leading-relaxed" data-id="element-21">
            Our commitment to quality, reliability, and exceptional service has
            established us as a trusted partner for property owners and managers
            throughout the UAE. Based in Al Jerf 3, Ajman, we pride ourselves on
            prompt response times, professional workmanship, and customer
            satisfaction in every project we undertake.
          </p>
        </div>
      </div>
    </section>;
}